import { EOrderStatus } from '@type/order';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { OrderStatus, OrderPayment } from './constants';
import { GetProp, message, UploadProps } from 'antd';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const findOrderStatus = (status: EOrderStatus) => {
  return [...OrderStatus, ...OrderPayment]?.find((o) => o?.key === status);
};

export type FileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0];

export const getBase64 = (img: FileType, callback: (url: string) => void) => {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result as string));
  reader.readAsDataURL(img);
};

export const beforeUpload = (file: FileType) => {
  const isJpgOrPng = file.type.includes('image');

  if (!isJpgOrPng) {
    message.error('Ảnh tải lên không đúng định dạng!');
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    message.error('Ảnh không được lớn hơn 2MB!');
  }
  return isJpgOrPng && isLt2M;
};

export function splitText(text: string = '', count: number): string {
  if (text?.length <= count * 2) return text;
  const start = text?.slice(0, count);
  const end = text?.slice(-count);
  return `${start}...${end}`;
}

export const applyIframeAspectRatio = (html: string) => {
  return html.replace(
    /<iframe\b([^>]*?)\bwidth=["']?(\d+)(px|%)?["']?([^>]*?)\bheight=["']?(\d+)(px|%)?["']?([^>]*)>/gi,
    (match, before1, width, widthUnit, middle, height) => {
      const w = parseInt(width, 10);
      const h = parseInt(height, 10);
      if (!w || !h) return match; // giữ nguyên nếu thiếu width/height

      const ratio = (w / h).toFixed(4);
      const existingStyleMatch = match.match(/style=["']([^"']*)["']/i);
      const existingStyle = existingStyleMatch ? existingStyleMatch[1] : '';

      const newStyle = existingStyle.includes('aspect-ratio')
        ? existingStyle
        : `${existingStyle ? `${existingStyle}; ` : ''}aspect-ratio:${ratio}`;

      if (existingStyleMatch) {
        return match.replace(existingStyleMatch[0], `style="${newStyle}"`);
      } else {
        return match.replace(/<iframe\b/i, `<iframe style="${newStyle}"`);
      }
    }
  );
};
